module.exports = __webpack_public_path__ + "547619b85f779c7a7618886b150395e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/containers/Help/screenshots/Wizard Page (8).png
// module id = 1051
// module chunks = 0